import { useTranslation } from 'react-i18next';

import { ReferralsElement } from '@shared/dream-components';

import { useReferralsContext } from '~/context/SubscriptionManagement';

/**
 * Renders the referrals block on the General tab — referral summary, rewards progress, and the
 * share link. Data and the copy handler come from `ReferralsProvider` via context. Pure UI, no
 * props, no data logic. Returns null when the publication has no referral program (or the
 * subscription is invalid); the caller positions it above the teaser when logged out and below
 * preferences when logged in.
 */
export const ReferralsSection = () => {
  const { t } = useTranslation();
  const {
    showReferrals,
    isLoadingReferrals,
    referrals,
    referralCount,
    referralLink,
    rewards,
    onClickCopyReferralLink,
  } = useReferralsContext();

  if (!showReferrals) {
    return null;
  }

  return (
    <ReferralsElement
      isLoading={isLoadingReferrals}
      element={{
        type: 'referrals',
        attrs: {
          data: {
            rewards: rewards ?? [],
            referrals,
            referral_count: referralCount,
            referral_link: referralLink,
          },
        },
      }}
      onClickCopy={onClickCopyReferralLink}
      translations={{
        'referrals.summary.title': t('referrals.summary.title'),
        'referrals.summary.description': t('referrals.summary.description'),
        'referrals.summary.show_more_button': t('referrals.summary.show_more_button'),
        'referrals.reward.disclaimer': t('referrals.reward.disclaimer'),
        'referrals.reward.progress.description': t('referrals.reward.progress.description'),
        'referrals.share.title': t('referrals.share.title'),
        'referrals.share.description': t('referrals.share.description'),
        'referrals.share.count': t('referrals.share.count'),
        'referrals.share.referred_count': t('referrals.share.referred_count'),
        'referrals.share.link_title': t('referrals.share.link_title'),
        'referrals.share.link_help_text': t('referrals.share.link_help_text'),
        'referrals.breakdown.confirmed': t('referrals.breakdown.confirmed'),
        'referrals.breakdown.pending': t('referrals.breakdown.pending'),
        'referrals.breakdown.no_confirmed': t('referrals.breakdown.no_confirmed'),
        'referrals.breakdown.no_pending': t('referrals.breakdown.no_pending'),
        'shared.cta.copy': t('shared.cta.copy'),
      }}
    >
      {null}
    </ReferralsElement>
  );
};
